var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsignee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54331 23.8538C6.93743 22.0263 0 13.8427 0 8.8677C0 3.96975 3.96975 0 8.87091 0C13.7689 0 17.7386 3.96975 17.7386 8.8677C17.7386 13.5087 10.7819 21.9717 9.19209 23.8474C9.02187 24.0465 8.71675 24.053 8.54331 23.8538Z",
    fill: "#155878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02621 4C9.51713 4 9.9151 4.39797 9.9151 4.88889V13.3175L12.5009 10.7318C12.848 10.3846 13.4108 10.3846 13.758 10.7318L14.0722 11.046C14.4194 11.3932 14.4194 11.956 14.0722 12.3031L9.43253 16.9428C9.08539 17.2899 8.52258 17.2899 8.17545 16.9428L3.53574 12.3031C3.18861 11.956 3.18861 11.3932 3.53574 11.046L3.85001 10.7318C4.19714 10.3846 4.75996 10.3846 5.10709 10.7318L7.69287 13.3175L7.69287 4.88889C7.69287 4.39797 8.09084 4 8.58176 4L9.02621 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsignee);
export default __webpack_public_path__ + "static/media/Consignee.82960a0511aae3115c5b20cb6668011f.svg";
export { ForwardRef as ReactComponent };